import { render } from "./KeywordRecent.vue?vue&type=template&id=3d85a0dc"
import script from "./KeywordRecent.vue?vue&type=script&lang=js"
export * from "./KeywordRecent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__